module.exports = __webpack_public_path__ + "media/assets/images/common/pinterest-d94b0be0bd838a8eff31000de8c75ef7.png";